import Checkboard from "./checkboard.vue";

export default Checkboard;
